import { ApiAuth } from "@/api/auth";
import { AuthLoginResource } from "@/api/generated-api";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { useForm } from "react-hook-form";
import { LOGIN_FORM_SCHEMA } from "../components/login/constants";

export const useLoginData = ({
  handleClose,
  redirectTo,
}: {
  handleClose: (isOpen: boolean) => void;
  redirectTo?: string;
}) => {
  const router = useRouter();

  const methods = useForm<AuthLoginResource>({
    resolver: zodResolver(LOGIN_FORM_SCHEMA),
    defaultValues: {
      email: "",
      password: "",
    },
    mode: "onSubmit",
    reValidateMode: "onChange",
  });

  const { mutate, isPending } = useMutation({
    mutationFn: (data: AuthLoginResource) => ApiAuth.login(data),
    onSuccess: () => {
      handleClose(false);
      router.push(redirectTo ?? "/profile");
    },
    onError: error => {
      const { message } = error;

      methods.setError("root.serverError", {
        type: "server",
        message,
      });
    },
  });

  const onSubmit = methods.handleSubmit(data => {
    mutate(data);
  });

  return { mutate, onSubmit, methods, isPending };
};
